import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AccountStatementAutoCompleteSearch } from '../../../../components/admin-dashboard-component/Account Statement/account-statement-auto-complete-search/account-statement-auto-complete-search';

@Component({
  selector: 'app-account-statement-auto-complete',
  imports: [AccountStatementAutoCompleteSearch],
  templateUrl: './account-statement-auto-complete.html',
  styleUrl: './account-statement-auto-complete.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountStatementAutoComplete {}
